/* eslint-env node */
/* eslint-disable global-require */

export default typeof window !== 'undefined' ? window.debug : require('de' + 'bug'); // This hack prevents Browserify to bundle debug
